import {
  ROLES
} from '../../config/constants'

export default (role) => {
  if (!role) return false

  if (role === ROLES.EXPERT || role === ROLES.AUTHOR) return true

  return false
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_user_expert.js
 **/